/**
 * FAQ contents rail, ported from src/pages/FAQ.tsx.
 *
 * Marks whichever section is highest in the viewport, and smooth-scrolls on
 * click while replacing the hash — matching the React handler. Active styling
 * is the same class set React applies: solid ink fill, inverted text.
 */
(function () {
  const links = [...document.querySelectorAll('[data-cs-toc]')];
  if (!links.length) return;

  const ACTIVE = ['bg-foreground', 'text-background', 'font-bold', 'border-foreground'];

  const setActive = (id) => {
    links.forEach((l) => {
      const on = l.dataset.csToc === id;
      ACTIVE.forEach((c) => l.classList.toggle(c, on));
      l.classList.toggle('text-foreground', !on);
    });
  };

  const sections = links
    .map((l) => document.getElementById(l.dataset.csToc))
    .filter(Boolean);

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    },
    { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
  );

  sections.forEach((s) => observer.observe(s));
  if (sections[0]) setActive(sections[0].id);

  links.forEach((l) => {
    l.addEventListener('click', (e) => {
      const el = document.getElementById(l.dataset.csToc);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + l.dataset.csToc);
    });
  });
})();
